import style from '../portfolio-items.module.css'
import Carousel from './embla-carousel/a22sbercity-embla.jsx'
import Portfolio from '../../../main/portfolio.jsx'
import ContactForm from '../../../main/contactForm.jsx'
import HireUs from '../../../forIndustrial/hireUs.jsx'

const OPTIONS = {}

export default function A22sbercity(props) {
    return (
        <div className={style.wrapper}>
            <div className={style.container}>
                <h1><span style={{color: '#ff8c00'}}>Солнечная станция</span><br /> для корпуса А22 ЖК «Сберсити»</h1>
                <Carousel options={OPTIONS} />
                <div className={style.description}>
                    <div className={style.tasks}>
                        <h6>Задача:</h6>
                        <p>Снизить энергопотребление корпуса А22 ЖК «Сберсити».</p>
                    </div>
                    <div className={style.specification}>
                        <div сlassName={style.info}>
                            <p><strong>Заказчик: </strong>ООО «Юнигрин Инжиниринг» (ГК «Хевел»).</p>
                            <p><strong>Конечный заказчик: </strong>АО «Сберсити».</p>
                            <p><strong>Дата: </strong>март - апрель 2026 г.</p>
                            <p><strong>Срок выполнения: </strong>25 рабочих дней.</p>
                            <h3 className={style.results}>Результаты работ:</h3>
                            <ul>
                                <li>Расчетная выработка СЭС составляет 69 МВт·ч в год.</li>
                                <li>Экономия составляет 600 000₽ в год.</li>
                            </ul>
                        </div>
                        <div className={style.solution}>
                            <h3>Решения для проекта:</h3>
                            <ul>
                                <li>Смонтирована крышная СЭС установленной мощностью 67,8 кВт.</li>
                                <li>Применены фотоэлектрические солнечные модули марки «Хевел» мощностью 565 Вт, сетевые солнечные инверторы Sungrow SG33CX мощностью 33 кВт (2 шт.).</li>
                                <li>Установлена система мониторинга солнечной станции.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <HireUs />
            <Portfolio />
            <div style={{height: '2rem'}}></div>
            <ContactForm />
        </div>
    )
}